import Accordion from "../../plugins/accordion.js";
import isMobile from "../../plugins/is-mobile.js";

/*サイドメニュー スマホ時アコーディオン */
if (isMobile(768)) {
  const elements = document.querySelectorAll(".js-accordion");
  for (const element of elements) {
    let side_accordion_sp = new Accordion(element, {
      // defaultOpenPanels: [0],
      multipleOpen: true,
      // onOpen: test,
      // onClose: fuga,
    });
  }
}

if (!isMobile(768)) {
const childLinks = document.querySelectorAll(".js-accordion-child");
for (const childLink of childLinks) {
  let side_childLink = new Accordion(childLink, {
    // defaultOpenPanels: [0],
    multipleOpen: true,
    trigger: ".js-accordion-child-trigger",
    panel: ".js-accordion-child-panel",
    // onOpen: test,
    // onClose: fuga,
  });
}
}

// let accordion = new Accordion(".js-accordion2", {
//   defaultOpenPanels: [0],
//   onOpen: hoge,
//   onClose: fuga
// });

// accordion.destroy()
// accordion.init()
